module.exports = __webpack_public_path__ + "static/media/typing.7117cc5b.png";